import Input from '../../../design/Input';


export default ({data, setData}) => {

    return (
        <div className="phoneEmail">
            <p> ש.פ. בעברית </p>
            <Input 
            myStyle='input2' 
            textView='שם פרטי' 
            pattern="strHe" 
            value={data.fnh} 
            onChange = {(e) => setData({...data, fnh: e})} 
            language="he" 
            />
            <p>ש.מ. בעברית</p>
            <Input 
            myStyle='input2' 
            textView='שם משפחה' 
            pattern="strHe" 
            value={data.lnh} 
            onChange = {(e) => setData({...data, lnh: e})} 
            language="he" 
            />
            <p> תעודת זהות </p>
            <Input 
            textView= 'ת.ז.' 
            myStyle='input2' 
            pattern="id" 
            value={data.id} 
            onChange = {(e) => setData({...data, id: e})} 
            />
            <p> תאריך לידה </p>
            <Input 
            type='date' 
            myStyle='input2' 
            value={data.dob} 
            onChange = {(e) => {setData({...data, dob: e}); console.log(e)}}
            pattern={'date'} 
            />
        </div>
    )
}